<template>
  <div class="max-w-1080px mx-auto my-10 md:my-20">
    <div class="flex items-center gap-1 text-5 font-semibold">
      <Logo size="30" color="currentColor" />
      <span>Orie</span>
    </div>
    <div class="mt-4 md:max-w-200">
      <h2 class="heading-1">Pricing for businesses of all sizes.</h2>

      <div class="mt-1 text-4 line-height-none md:max-w-200 opacity-70">
        Full access to any plan for A$1/month for your first 2 months—risk-free
        and cancel anytime.
      </div>
    </div>

    <div class="mt-8">
      <PricingDetails :loading="loading" :plans="plans" />
    </div>
  </div>
</template>

<script lang="ts">
import PricingDetails from "@/components/pages/pricing";

export default defineComponent({
  components: {
    PricingDetails,
  },
  setup() {
    definePageMeta({
      layout: "blank",
    });

    const { loading, plans } = usePlans();

    return {
      loading,
      plans,
    };
  },
});
</script>
